module.exports = __webpack_public_path__ + "static/dd2-68d68135d9bcd4ff775eb7caeba90e23.jpg";